export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const competencies = [
    'Лидерство', 'Управление командой', 'Делегирование', 'Коммуникации',
    'Переговоры', 'Решения', 'Изменения', 'Развитие сотрудников',
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20conceptual%20illustration%20about%20developing%20management%20competencies%20and%20leadership%20skills%2C%20a%20confident%20manager%20silhouette%20standing%20at%20the%20center%20of%20interconnected%20skill%20nodes%20representing%20delegation%20communication%20feedback%20negotiation%20decision%20making%20and%20change%20management%2C%20geometric%20elements%20and%20connecting%20lines%20forming%20a%20growth%20system%2C%20deep%20teal%20and%20emerald%20green%20color%20palette%20with%20warm%20cream%20highlights%2C%20soft%20gradient%20background%2C%20minimalist%20corporate%20art%20style%2C%20sense%20of%20systematic%20growth%20and%20capability%20building%2C%20elegant%20premium%20editorial%20design%20aesthetic%2C%20generous%20negative%20space%2C%20no%20text%20no%20logos%20no%20branding&width=1920&height=1080&seq=razvitie-upravlencheskih-kompetenciy-hero-2026&orientation=landscape"
          alt="Развитие управленческих компетенций руководителей и менеджеров"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-32 md:pt-24 pb-12 md:pb-16">
        <div className="max-w-3xl">
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            Развитие управленческих компетенций: руководители, которые умеют управлять результатом
          </h1>
          <p className="text-sm md:text-lg text-white/85 mb-4 leading-relaxed max-w-xl">
            Развиваем навыки руководителей, которые помогают ставить задачи, делегировать, давать обратную связь, принимать решения, управлять командой, конфликтами и изменениями.
          </p>
          <p className="text-sm text-white/60 mb-6">
            Корпоративные программы развития управленческих компетенций для руководителей и управленческих команд в Минске, Беларуси и онлайн.
          </p>

          <div className="flex flex-wrap gap-2 mb-8">
            {competencies.map((c) => (
              <span key={c} className="bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 px-3 py-1.5 rounded-full text-xs font-medium">
                {c}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => scrollTo('contact')}
              className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Усилить управленческие компетенции
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollTo('contact')}
              className="border border-white/30 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/10 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить задачи компании
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}